import React, { useEffect, useState } from 'react'
import FeedSummary from './FeedSummary'
import PaymentSummary from './PaymentSummary'
import { apiSubPackages } from 'services/BillingService'
import { useSelector } from 'react-redux'
import { Skeleton } from 'components/ui'

const PanelContent = React.memo(({ termsOfUseContent }) => {
    const { premiumTitlesCount, standardTitlesCount } = useSelector(
        (state) => state.checkout.titles
    )
    const [packages, setPackages] = useState([])
    const [selectedPackage, setSelectedPackage] = useState(null) // first package index
    const { changePackageTo } = useSelector(
        (state) => state.checkout.selectPlan
    )
    useEffect(() => {
        const fetchData = async () => {
            const response = await apiSubPackages()
            if (response.data) {
                setPackages(response.data.data)
            }
        }

        fetchData()
    }, [premiumTitlesCount, standardTitlesCount])

    useEffect(() => {
        if (packages.length) {
            const preSelectedPackage = packages.find(
                (packageData) =>
                    packageData.premium_num >= premiumTitlesCount &&
                    packageData.standard_num >= standardTitlesCount
            )

            // console.log('preSelectedPackage', preSelectedPackage)
            preSelectedPackage
                ? setSelectedPackage(preSelectedPackage)
                : setSelectedPackage(packages[0])
        }
    }, [packages, premiumTitlesCount, standardTitlesCount])

    return (
        <div className="flex h-full">
            <div className="w-1/2 h-full bg-gray-100">
                <div className="overflow-auto h-full w-full">
                    <div className="flex justify-center items-center">
                        <div className="w-11/12 mt-10">
                            {packages.length ? (
                                <FeedSummary
                                    packages={packages}
                                    selectedPackage={selectedPackage}
                                    setSelectedPackage={setSelectedPackage}
                                />
                            ) : (
                                <div className="flex flex-col gap-4">
                                    <Skeleton height={20} />
                                    <Skeleton height={20} />
                                    <Skeleton height={20} />
                                    <Skeleton height={20} />
                                    <Skeleton height={20} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-1/2 h-full">
                <div className="overflow-auto h-full w-full">
                    <div className="flex justify-center items-center">
                        <div className="w-11/12 mt-10">
                            <PaymentSummary
                                termsOfUseContent={termsOfUseContent}
                                selectedPackage={
                                    changePackageTo?.id
                                        ? changePackageTo
                                        : selectedPackage
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
})

export default PanelContent
